// 应用类别
export const appTypeDic = [
  {
    key: -1,
    value: "请选择"
  },
  {
    key: 1,
    value: "电子存证"
  },
  {
    key: 2,
    value: "版权"
  },
  {
    key: 3,
    value: "电子档案"
  },
  {
    key: 4,
    value: "溯源"
  },
  {
    key: 5,
    value: "其他"
  }
];

// 平台类型
export const platformTypeDic = [
  {
    key: 1,
    value: "web"
  }
];

// 字典类型
export const dictTypeDic = [
  {
    key: 1,
    value: "通用模板"
  },
  {
    key: 2,
    value: "用户模板"
  }
];

// 业务类型
export const applyTypeDic = [
  {
    key: -1,
    value: "请选择"
  },
  {
    key: 1,
    value: "主体"
  },
  {
    key: 2,
    value: "行为"
  }
];

// 主体类型
export const subjectTypeDic = [
  {
    key: -1,
    value: "请选择"
  },
  {
    key: 1,
    value: "个人"
  },
  {
    key: 2,
    value: "企业"
  },
  {
    key: 3,
    value: "其他"
  }
];

// 主体类型
export const businessTypeDic = [
  {
    key: -1,
    value: "请选择"
  },
  {
    key: 1,
    value: "司法存证"
  },
  {
    key: 2,
    value: "电子版权"
  },
  {
    key: 3,
    value: "区块链"
  },
  {
    key: 4,
    value: "溯源"
  },
  {
    key: 5,
    value: "其他"
  }
];

// 实名认证类型
export const memberAuthTypeDic = [
  {
    key: 1,
    value: "个人"
  },
  {
    key: 2,
    value: "企业"
  }
];

// 审核状态类型
export const memberVerifyTypeDic = [
  {
    key: -1,
    value: "未提交"
  },
  {
    key: 1,
    value: "待审核"
  },
  {
    key: 2,
    value: "审核通过"
  },
  {
    key: 2,
    value: "审核未通过"
  }
];

// 交易状态类型
export const transStatusTypeDic = [
  {
    key: 1,
    value: "交易成功，数据上链失败"
  },
  {
    key: 2,
    value: "交易，上链成功"
  }
];

// 证书类型
export const certinfoTypeDic = [
  {
    key: -1,
    value: "请选择"
  },
  {
    key: 1,
    value: "个人证书"
  },
  {
    key: 2,
    value: "企业证书"
  }
];

// 证书用户类型
export const certinfoUserTypeDic = [
  {
    key: -1,
    value: "请选择"
  },
  {
    key: 1,
    value: "个人"
  },
  {
    key: 2,
    value: "企业"
  }
];

// 证书购买类型
export const certinfoBuyTypeDic = [
  {
    key: 0,
    value: "未购买"
  },
  {
    key: 1,
    value: "已购买"
  },
  {
    key: 2,
    value: "过期"
  }
];

// 证书签发类型
export const certinfoIssueTypeDic = [
  {
    key: 1,
    value: "签发成功"
  },
  {
    key: 2,
    value: "签发失败"
  }
];
